<template>
  <div class="content">
    <div class="page-menu-list-warp" ref="left">
      <ul class="page-menu-list">
        <li
          class="menu-item menu-item-hook"
          :class="{ active: leftActive == index }"
          v-for="(item, index) in menuList"
          :key="item.id"
          @click="selectMenu(index)"
        >
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <div class="page-goods-list" ref="right">
      <div ref="warp">
        <goods-warp
          class="goods-warp-hook"
          v-for="item in goodsList"
          :key="item.name"
          :items="item"
        ></goods-warp>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import { getGoods } from "@/api";
import goodsWarp from "./goodsWarp";

export default {
  data() {
    return {
      rightScrollY: 0,
      hList: [],
      menuList: [],
      goodsList: [],
    };
  },
  created() {
    getGoods().then((d) => {
      this.menuList = d.data.map((d, i) => {
        return {
          id: i,
          name: d.name,
        };
      });

      this.goodsList = d.data;

      this.$nextTick(() => {
        this.initScroll();
      });
    });
  },
  computed: {
    leftActive() {
      for (var i = 0; i < this.hList.length; i++) {
        var h1 = this.hList[i];
        var h2 = this.hList[i + 1];
        if (this.rightScrollY >= h1 && this.rightScrollY < h2) {
          return i;
        }
      }
      return 0;
    },
  },
  watch: {
    leftActive(v) {
      var dom = document.getElementsByClassName("menu-item-hook")[v];
      this.leftScroll.scrollToElement(dom, 300);
    },
  },
  methods: {
    // 左边菜单选择并调到指定位置
    selectMenu(i) {
      var dom = this.$refs["warp"].getElementsByClassName("goods-warp-hook")[i];
      this.rightScroll.scrollToElement(dom, 300);
    },
    // 初始化滾動
    initScroll() {
      // 左边滚动初始化
      this.leftScroll = BScroll(this.$refs["left"], {
        click: true,
      });
      // 右边滚动初始化
      this.rightScroll = BScroll(this.$refs["right"], {
        probeType: 3,
        click: true,
      });

      //监听滚动变化
      this.rightScroll.on("scroll", (d) => {
        this.rightScrollY = d.y * -1;
      });

      // 记录右侧模块高度
      var _hList = [0];
      var h = 0;

      var warpList = this.$refs["warp"].getElementsByClassName(
        "goods-warp-hook"
      );

      for (var i = 0; i < warpList.length; i++) {
        h += warpList[i].clientHeight;
        _hList.push(h);
      }

      this.hList = _hList;
    },
  },
  components: {
    goodsWarp,
  },
};
</script>

<style lang="scss" scoped>
.content {
  flex: 1;
  overflow: hidden;
  display: flex;
}

.page-menu-list-warp {
  width: 174px;
  background: #f7f7f7;

  .page-menu-list {
    z-index: 10;

    .menu-item {
      height: 116px;
      display: flex;
      align-items: center;
      padding: 0px 30px;
      transition: all 0.3s;
      color: #999;

      &.active {
        background: #ffff;
        font-weight: bold;
        color: #333;
      }
    }
  }
}

.page-goods-list {
  flex: 1;
  & > div {
    padding-top: 1px;
  }
}

.placeholder {
  height: 140px;
}
</style>
